import React from 'react';
import PropTypes from 'prop-types';

import plusIcon from '../../assets/images/expandor.svg';
import minusIcon from '../../assets/images/contractor.svg';
import expandIcon from '../../assets/images/expanded-indicator.svg';

import './ExpandableSection.scss';

export default class ExpandableSection extends React.Component {
  constructor(props) {
    super(props);
    ExpandableSection.propTypes = {
      // Special react prop used to transclude child elements within this component
      children: PropTypes.any,
      // Initial state of the setion - defaults to false (contracted) if none given
      initiallyExpanded: PropTypes.bool,
      // Name to be displayed on the left of the section heading
      name: PropTypes.string,
      // Callback fired when expanded/contracted
      onExpand: PropTypes.func,
      // If true, this is nested inside another <ExpandableSection>
      // currently only one level of nesting is supported
      isSubSection: PropTypes.bool,
      // If true, there will be an expand icon to the left instead of 
      // the default plus/minus icon to the right
      useExpandIcon: PropTypes.bool,
      // an optional id to be applied to the root <div>
      id: PropTypes.string,
      // an optional icon to display (expects a url)
      icon: PropTypes.string,
      additionClass: PropTypes.string,
    };
    this.state = {
      expanded: (!props.animateExpand && props.initiallyExpanded) || false,
    };
    this.expandOrContract = this.expandOrContract.bind(this);
    this.checkExpandOrContract = this.checkExpandOrContract.bind(this);
  }

  componentDidMount() {
    if (this.props.animateExpand) {
      setTimeout(() => {
        if (this.props.onExpand) {
          this.props.onExpand(!this.state.expanded);
        }
        this.setState({ expanded: true });
      }, 100);
    }
    else if (this.props.initiallyExpanded) {
      this.setState({ expanded: true });
    }
  }

  componentDidUpdate(prevProps) {
    const { initiallyExpanded } = this.props;
    if (prevProps.animateExpand != this.props.animateExpand) {
      setTimeout(() => {
        if (this.props.onExpand) {
          this.props.onExpand(!this.state.expanded);
        }
        this.setState({ expanded: true });
      }, 100);
    }
    else if (!this.props.animateExpand && prevProps.initiallyExpanded != initiallyExpanded && initiallyExpanded) {
      this.setState({ expanded: initiallyExpanded });
    }
  }

  checkExpandOrContract(e) {
    if (e) {
      e.stopPropagation();
    }
    if (this.props.onClick) {

      this.props.onClick(this.props.onClickData);
    }
    if (this.props.onClear) {

      this.props.onClear();
    }
    else {
      this.expandOrContract(e);
    }
  }

  expandOrContract(e) {
    if (e) {
      e.stopPropagation();
    }
    if (this.props.onExpand) {
      this.props.onExpand(!this.state.expanded);
    }
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const { expanded } = this.state;
    const { isSubSection, useExpandIcon, id, hasBreakLine, icon, additionClass } = this.props;
    const baseClassName = isSubSection ? 'expandable-subsection' : 'expandable-section';
    let users=this.props.numberUsers?parseInt(this.props.numberUsers,10):0;
    
    return (
      <div className={baseClassName + (expanded ? ' '+baseClassName+'--expanded' : '') + (expanded && this.props.hovered ? ' hovered': '') + ' ' + additionClass} id={id}>
        {
          useExpandIcon && expanded &&
          <img 
          className={baseClassName+'__icon ' + baseClassName+'__icon--left'} 
          onClick={this.checkExpandOrContract}
          src={expandIcon} 
          alt='expanded'
          />
        }
        { icon &&
            <div className={baseClassName+'__usericon_container'}>
              <img className={baseClassName+'__usericon'} src={icon} alt={this.props.name}/>
              <span className={baseClassName+'__name'} onClick={this.checkExpandOrContract}>
          { this.props.name }
        </span>
            </div>
        }{
          !icon && 
          <span className={baseClassName+'__name'} onClick={this.checkExpandOrContract}>
          { this.props.name }
        </span>
        }
        
        {hasBreakLine && <hr className={baseClassName+'_break'}/>}
        {
          !useExpandIcon &&
          <img 
          className={baseClassName+'__icon ' + baseClassName+'__icon--right' } 
          onClick={this.expandOrContract}
          src={expanded ? minusIcon : plusIcon} 
          alt={expanded ? 'minus' : 'plus'}
          />
        }
        <div className={baseClassName+'__content'} style={{ height: users!=0? ''+(users*72) +'px': '250px',  
        maxHeight: users!=0 && expanded? ''+(users*72) +'px': users!=0 && !expanded?'0px':users==0 && !expanded?'0px':users==0 && expanded?'550px':'250px', 
        transition: expanded?'max-height .3s ease-in 0s':'max-height .3s ease-out 0s' }} >
          {this.props.children}
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/ExpandableSectionMembers/index.js